<template>
  <div>
    <a-tabs default-active-key="1" @change="callback">
      <a-tab-pane key="1" tab="晚自习辅导统计">
        <div>
            <div class="search-box">
                <p>系别：</p>
                <a-select class="input-box" allowClear v-model="tjSearchFrom.departmentCode" >
                    <a-select-option v-for="(item,index) in xbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                </a-select>
                <p>学年：</p>
                <a-date-picker
                    class="input-box"
                    mode="year"
                    format='YYYY'
                    v-model="tjYear" 
                    :open='tjYearShowOne' 
                    @openChange="tjOpenChangeOne"
                    @panelChange="tjPanelChangeOne">
                    <a-input  v-model="tjSearchFrom.schoolYear" />
                </a-date-picker>
                <!-- <a-date-picker
                    class="input-box"
                    mode="year"
                    format='YYYY'
                    v-model="tjYear" 
                    :open='tjYearShowOne' 
                    @openChange="tjOpenChangeOne"
                    @panelChange="tjPanelChangeOne">
                    <a-input  v-model="tjSearchFrom.year" />
                </a-date-picker> -->
                <p>职称：</p>
                <a-select class="input-box" allowClear v-model="tjSearchFrom.technicalTitleCode" >
                    <a-select-option v-for="(item,index) in zcArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                </a-select>
                <p>教师姓名：</p>
                <a-input class="input-box" v-model="tjSearchFrom.teacherName" />
                

                <a-button type="primary" icon="search" @click="searchTjList">搜索</a-button>

            </div>
            <div class="operation-box">
                <a-button type="primary" class="btn" icon="download"  @click="exportTjTable">导出Excel</a-button>
            </div>
            <a-table 
                rowKey='id'
                :columns="tjColumns" 
                :data-source="tjData"
                :loading="loading"
                :pagination="pagination"
                @change="handleTjTableChange"
                :scroll="{ x: '100%' }"
                bordered>
            </a-table>
        </div>
      </a-tab-pane>
      <a-tab-pane key="2" tab="晚自习辅导明细" force-render>
        <div>
            <div class="search-box">
                <p>系别：</p>
                <a-select class="input-box" allowClear v-model="searchFrom.departmentCode" >
                    <a-select-option v-for="(item,index) in xbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                </a-select>
                <p>学年：</p>
                <a-date-picker
                    class="input-box"
                    mode="year"
                    format='YYYY'
                    v-model="year" 
                    :open='yearShowOne' 
                    @openChange="openChangeOne"
                    @panelChange="panelChangeOne">
                    <a-input  v-model="searchFrom.schoolYear" />
                </a-date-picker>
                <p>学期：</p>
                <a-select class="input-box" @change="timeSetCurrent()" allowClear v-model="searchFrom.semester" >
                    <!-- For years before 2025, keep all options -->
                    <template v-if="year < '2025'">
                        <a-select-option :value="year+'A'">秋季学期</a-select-option>
                        <a-select-option :value="year+'B'">冬季学期</a-select-option>
                        <a-select-option :value="(year-0+1)+'C'">春季学期</a-select-option>
                    </template>
                    <!-- For 2025 and later, only show two semesters -->
                    <template v-else>
                        <a-select-option :value="year+'A'">秋季学期</a-select-option>
                        <a-select-option :value="(year-0+1)+'C'">春季学期</a-select-option>
                    </template>
                </a-select>
                <p>教师姓名：</p>
                <a-input class="input-box" v-model="searchFrom.teacherName" />
                <a-button type="primary" icon="search" @click="searchList">搜索</a-button>

            </div>
            <div class="operation-box">
                <a-button 
                    type="primary"
                    icon="plus" 
                    class="btn"
                    v-if="permissions.indexOf('undergraduate:culture:nightCoaching:add')>-1 && enbale"
                    @click="$router.push('/admin/undergraduate/nightCoaching/info?type=add')"
                    >
                    新增
                </a-button>
                <a-popconfirm placement="top" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="remove(selectedRowKeys[0])">
                    <a-button
                        v-if="permissions.indexOf('undergraduate:culture:nightCoaching:delete')>-1 && enbale"
                        type="primary"
                        icon="minus" 
                        class="btn" 
                        >
                        删除
                    </a-button>
                </a-popconfirm>
                <a-button 
                    type="primary"
                    icon="edit" 
                    class="btn"
                    v-if="permissions.indexOf('undergraduate:culture:nightCoaching:edit')>-1 && enbale"
                    @click="nightCoaching('edit')"
                    >
                    修改
                </a-button>
                <a-button type="primary" v-if="permissions.indexOf('undergraduate:culture:nightCoaching:query')>-1" class="btn" icon="file-search" @click="nightCoaching('look')" >查看详情</a-button>
                <a-button type="primary" class="btn" icon="download"  @click="exportTable">导出Excel</a-button>
                <a-button type="primary" class="btn" icon="edit" v-if="permissions.indexOf('undergraduate:culture:nightCoaching:timeSet:query')>-1"  @click="$router.push('/admin/undergraduate/nightCoaching/timeSet')">填报时间</a-button>

            </div>
            <a-table 
                rowKey='id'
                :customRow="onClickRow"
                :columns="columns" 
                :data-source="data"
                :loading="loading"
                :pagination="pagination"
                @change="handleTableChange"
                :scroll="{ x: '100%' }"
                :row-selection="{ type:'radio',selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                bordered>
            </a-table>
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { list,del,tjList,exportTable,exportTjTable,timeSetCurrent } from '@/baseAPI/undergraduate/culture/nightCoaching'
    import { getSchoolYear,getSemester,transformSeason } from '@/baseAPI/util'
    export default {
        data() {
            return {
                zcArr:[],
                xbArr:[],
                data:[],
                tjData:[],
                loading: false,
                pagination:{
                    pageSize: 10,
                    current: 1,
                    total:0,
                },
                selectedRowKeys: [],
                searchFrom:{
                    size: '',
                    current: '',
                    studentNoOrName:'',
                    teacherName:'',
                    checkLevel:'',
                    semester:'',
                    schoolYear:'',
                    departmentCode:'',
                    technicalTitleCode:'',
                    year:''
                },
                tjSearchFrom:{
                    size: '',
                    current: '',
                    studentNoOrName:'',
                    teacherName:'',
                    checkLevel:'',
                    semester:'',
                    schoolYear:'',
                    departmentCode:'',
                    technicalTitleCode:'',
                    year:''
                },
                permissions:[],
                year:'',
                tjYear:'',
                yearShowOne:false,
                tjYearShowOne:false,
                courseId:'',
                season:{'3':'C','4':'C','5':'C','6':'D','7':'D','8':'D','9':'A','10':'A','11':'A','12':'B','1':'B','2':'B'},
                sysRoles:[],
                tjColumns:[
                    {
                            title: '序号',
                            align:'center',
                            width:'4%',
                            customRender: (text, row, index) => {
                                return { children: index+1+''};
                            },
                            
                        },
                        {
                            title: '学年',
                            dataIndex: 'schoolYear',
                            align:'center',
                            width:'8%',
                        },
                        {
                            title: '系别',
                            dataIndex: 'orgName',
                            align:'center',
                            width:'6%',
                        },
                        {
                            title: '教师姓名',
                            dataIndex: 'teacherName',
                            align:'center',
                            width:'7%',
                        },
                        {
                            title: '教师编号',
                            dataIndex: 'teacherId',
                            align:'center',
                            width:'8%',
                        },
                        {
                            title: '职称',
                            dataIndex: 'technicalTitleName',
                            align:'center',
                            width:'7%',
                        },
                        
                        {
                            title: '秋季学期晚自习数',
                            dataIndex: 'autumnCnt',
                            width:'7%',
                            align:'center'
                        },
                        {
                            title: '冬季学期晚自习数',
                            dataIndex: 'winterCnt',
                            align:'center',
                            width:'7%',
                        },
                        {
                            title: '春季学期晚自习数',
                            dataIndex: 'springCnt',
                            align:'center',
                            width:'7%',
                        },
                        {
                            title: '学年晚自习数',
                            dataIndex: 'sum',
                            align:'center',
                            width:'7%',
                        },
                        {
                            title: '提示',
                            dataIndex: 'tips',
                            align:'center'
                        }
                ],
                columns:[
                        {
                            title: '序号',
                            align:'center',
                            width:'4%',
                            customRender: (text, row, index) => {
                                return { children: index+1+''};
                            },
                            
                        },
                        {
                            title: '学年',
                            dataIndex: 'schoolYear',
                            align:'center',
                            width:'8%',
                        },
                        {
                            title: '学期',
                            dataIndex: 'semester',
                            align:'center',
                            width:'6%',
                            customRender: (text, row, index) => {
                                return transformSeason(text);
                            },
                        },
                        {
                            title: '系别',
                            dataIndex: 'orgName',
                            align:'center',
                            width:'6%',
                        },
                        {
                            title: '教师姓名',
                            dataIndex: 'teacherName',
                            align:'center',
                            width:'7%',
                        },
                        {
                            title: '教师编号',
                            dataIndex: 'teacherId',
                            align:'center',
                            width:'8%',
                        },
                        {
                            title: '职称',
                            dataIndex: 'technicalTitleName',
                            align:'center',
                            width:'7%',
                        },
                        {
                            title: '辅导时间',
                            dataIndex: 'coachingTime',
                            align:'center',
                            width:'12%',
                        },
                        {
                            title: '辅导地点',
                            dataIndex: 'coachingRoom',
                            align:'center'
                        },
                        {
                            title: '校区',
                            dataIndex: 'campus',
                            align:'center',
                            width:'8%',
                        },
                        {
                            title: '学期晚自习数',
                            dataIndex: 'nightCnt',
                            align:'center'
                        },
                        {
                            title: '学年晚自习数',
                            dataIndex: 'nightSum',
                            align:'center'
                        }
                    ],
                currentTimeSet:{},
                enbale:true
            };
        },
        mounted () {
            this.$store.state.user.sysRoles.forEach(element => {
                this.sysRoles.push(element.code)
            });
            getDicts({dataCode:'XY',status:true}).then(res=>{
                this.xbArr=res.data.dicts;
            })
            getDicts({dataCode:'ZC',status:true}).then(res=>{
                this.zcArr=res.data.dicts;
            })
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            this.searchFrom.schoolYear=getSchoolYear()+'-'+(getSchoolYear()+1)
            this.year=getSchoolYear()+''
            this.tjYear=getSchoolYear()+1+''
            this.searchFrom.semester=getSemester()

            this.tjSearchFrom.schoolYear=getSchoolYear()+'-'+(getSchoolYear()+1)
            this.tjYear=getSchoolYear()+''
            this.tjSearchFrom.year=getSchoolYear()+''
            this.fetch()
            this.tjFetch()
            this.timeSetCurrent()
        },
        methods: {
            timeSetCurrent(){
                timeSetCurrent().then(res=>{
                    this.currentTimeSet = res.data
                    if(new Date().getTime() > new Date(this.currentTimeSet.endDate).getTime() 
                    || new Date().getTime() < new Date(this.currentTimeSet.startDate).getTime()){
                        this.enbale = false
                    }else{  
                        this.enbale=true
                    }
                    
                })
            },
            exportTable(){
                exportTable(this.searchFrom).then(res => {
                    window.open(this.$store.state.axiosUrl+'/api-f/statics/tempFileDirectory/'+res.data)
                })
            }, 
            exportTjTable(){
                exportTjTable(this.tjSearchFrom).then(res => {
                    window.open(this.$store.state.axiosUrl+'/api-f/statics/tempFileDirectory/'+res.data)
                })
            }, 
            callback(key) {
                console.log(key);
            },
            onClickRow(record,index){
                return {
                    on: { // 事件
                        click: (event) => {
                            this.courseId=record.courseInfoId
                            this.onSelectChange([record.id])
                        }
                    },

                }  
            },
            handleTableChange(pagination){
                this.selectedRowKeys=[];
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                this.pagination = pager;
                this.fetch();
            },
            handleTjTableChange(pagination){
                this.selectedRowKeys=[];
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                this.pagination = pager;
                this.tjFetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                this.data = []
                list(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.data = res.data.records
                    this.loading = false;
                })

            },
            tjFetch() {
                this.loading = true;
                this.tjSearchFrom.size=this.pagination.pageSize;
                this.tjSearchFrom.current=this.pagination.current;
                this.tjData = []
                tjList(this.tjSearchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.tjData = res.data.records
                    this.loading = false;
                })

            },
            searchList(){
                this.pagination.current=1;
                this.fetch()
            },
            searchTjList(){
                this.pagination.current=1;
                this.tjFetch()
            },
            remove(id){
                if(this.selectedRowKeys.length>0){
                    del(id).then(res=>{
                        if(res.data.success){
                            this.$notification['success']({
                                message: '成功',
                                description:'删除晚自习辅导信息成功',
                            });
                            this.fetch()
                        }else{
                            this.$notification['error']({
                                message: '失败',
                                description:res.data.errorMessage,
                            });
                        }
                    })
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择一条记录再进行操作！',
                    });
                }
            },
            // 弹出日历和关闭日历的回调
            openChangeOne(status) {
                    if (status){
                        this.yearShowOne =  true
                    }
                },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.year=this.getTimeStr(value._d,'yyyy')
                this.searchFrom.schoolYear=this.year+'-'+(this.year-0+1);
                this.searchFrom.semester='';
                this.yearShowOne = false;
            },
            // 弹出日历和关闭日历的回调
            tjOpenChangeOne(status) {
                    if (status){
                        this.tjYearShowOne =  true
                    }
                },
            // 得到年份选择器的值
            tjPanelChangeOne(value) {
                this.tjYear=this.getTimeStr(value._d,'yyyy')
                this.tjSearchFrom.schoolYear=this.tjYear+'-'+(this.tjYear-0+1);
                this.tjYearShowOne = false;
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
                console.log(selectedRowKeys)
            },
            nightCoaching(type){
                if(this.selectedRowKeys.length>0){
                    this.$router.push('/admin/undergraduate/nightCoaching/info?type='+type+'&id='+this.selectedRowKeys[0])
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择一条记录再进行操作！',
                    });
                }
            }
        },
    };
</script>
<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 10px;
        margin-top: 20px;
    }
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 10rem;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }
    .ant-dropdown-link{
        display: inline-block;
        font-size: 0.9rem;
    }
    .operation-box{
        display: flex;
        margin-bottom: 10px;
    }

    .operation-box .btn{
        margin-right: 1rem;
    }
</style>